import React from 'react';
import './ConfirmModal.scss';
import {  ImCancelCircle } from   'react-icons/im';

function ConfirmModal({onClose, onAccept, title="Are you sure you want to delete ?" }) {

    return (
        <>
        <div  className='modal-container'>
        <p className="modal-title">{title}</p>
            <div className='modal-content'>
                <button onClick={onAccept} className="bg-red-500 w-[100%] text-[#fff] py-2 rounded my-2">Yes</button>
                <button onClick={onClose} className="bg-gray-700 w-[100%] text-[#fff] py-2 rounded my-2">No</button>
            </div>
        </div>
        <div className="modal-shadow">

        </div>
        </>
    );
}

export default ConfirmModal;